import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ContentUtil } from '../../../../utils/content/content.util';
import { Observable, Subscription } from 'rxjs';
import { BreakpointObserverService } from '../../../../services/breakpoint-observer/breakpoint-observer.service';
import { AccessTypeSelection } from '../../../../../common/enums/access-type-selection.enum';
import { CtaCallUsLinkLocations } from '../../../../services/adobe-launch/adobe-launch.cta';
import { selectGranteeAccessType } from '../../../../store/selectors/grantee.selector';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs/operators';
import { VgnService } from '../../../../services/vgn/vgn.service';
import { AdobeTagging } from '../../../../utils/decorators/dev/adobe-launch';
import { configData } from './grantee-welcome-page-adobe';
import { LiteRegRedirect } from '../../../../store/actions/pvr-redirect.actions';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { LoggerService } from '../../../../services/logger/logger.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { ButtonModule } from '@vg-constellation/angular-20/button';

@AdobeTagging(configData)
@Component({
    selector: 'zci-grantee-welcome-page',
    templateUrl: './grantee-welcome-page.component.html',
    styleUrls: ['./grantee-welcome-page.component.scss'],
    imports: [
        AsyncPipe,
        NgIf,
        ButtonModule,
    ],
})
export class GranteeWelcomePageComponent implements OnInit, OnDestroy {
    private readonly breakpointObserverService = inject(BreakpointObserverService);
    private readonly store = inject(Store);
    private readonly vgnService = inject(VgnService);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly logger = inject(LoggerService);

    readonly accessTypeSelection = AccessTypeSelection;

    isMobileView$: Observable<boolean> = this.breakpointObserverService.isMobileView$;

    readonly subs: Subscription = new Subscription();

    granteeAccessType$: Observable<AccessTypeSelection> =
        this.store.select(selectGranteeAccessType);

    accessType: AccessTypeSelection;

    adobeTrackActionLocationInfoOnly: CtaCallUsLinkLocations =
        CtaCallUsLinkLocations.ZCI_WELCOME_PAGE_INFO_ONLY;

    adobeTrackActionLocationLimited: CtaCallUsLinkLocations =
        CtaCallUsLinkLocations.ZCI_WELCOME_PAGE_LIMITED;

    adobeLocationData: CtaCallUsLinkLocations;

    environment = environment;

    welcomePageContent = ContentUtil.granteeWelcomeContent;

    ngOnInit(): void {
        this.subs.add(
            this.granteeAccessType$.subscribe((accessType) => {
                this.accessType = accessType;
                this.logger.info(`Welcome page successfully loaded for ${accessType} access type`);
                switch (accessType) {
                    case this.accessTypeSelection.INFORMATION_ONLY:
                        this.adobeInfoOnlyPageLoad();
                        break;
                    case this.accessTypeSelection.LIMITED_ACCESS:
                        this.adobeLimitedOnlyPageLoad();
                        break;
                }
            }),
        );
        this.vgnService.setMinimalNav(true);
    }

    private adobeInfoOnlyPageLoad(): void { }

    private adobeLimitedOnlyPageLoad(): void { }

    private adobeNextStepLoadInfoOnly(): void { }

    private adobeNextStepLoadLimited(): void { }

    private handleNextStepLoadAdobe(): void {
        this.subs.add(
            this.granteeAccessType$.subscribe((accessType) => {
                this.accessType = accessType;
                switch (accessType) {
                    case this.accessTypeSelection.INFORMATION_ONLY:
                        this.adobeNextStepLoadInfoOnly();
                        break;
                    case this.accessTypeSelection.LIMITED_ACCESS:
                        this.adobeNextStepLoadLimited();
                        break;
                }
            }),
        );
    }

    public getAccessType(): Subscription {
        return this.granteeAccessType$.pipe(take(1)).subscribe((accessType) => {
            this.accessType = accessType;
        });
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    onGetStartedClickedInfoOnly(): void {
        this.onGetStartedClicked();
    }

    onGetStartedClickedLimited(): void {
        this.onGetStartedClicked();
    }

    private onGetStartedClicked(): void {
        this.handleNextStepLoadAdobe();
        const token = this.getToken(this.activatedRoute.snapshot);
        setTimeout(() => {
            this.store.dispatch(LiteRegRedirect({ token: token }));
        }, 300);
    }

    private getToken(route: ActivatedRouteSnapshot): string {
        return route.queryParams['token'] || route.params.token;
    }
}
